<template>
	<app-tooltip
		class="app-scroll-top-tooltip"
		:text="$t('ui_scroll_top')"
		:disabled="!props.enabled"
	>
		<template #activator>
			<button
				:class="{
					'app-scroll-top': true,
					'app-scroll-top--enabled': props.enabled
				}"
				type="button"
				:aria-label="$t('ui_scroll_top')"
				@click="emit('on-click')"
			>
				<app-icon
					name="arrow-up"
					width="24px"
					color="#fff"
				/>
			</button>
		</template>
	</app-tooltip>
</template>

<script setup lang="ts">
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";

type scrollTopButtonProps = {
	enabled: boolean;
}

type scrollTopButtonEmit = {
	"on-click": [];
}

const props = withDefaults(defineProps<scrollTopButtonProps>(), {
	enabled: false
})

const emit = defineEmits<scrollTopButtonEmit>()
</script>

<style scoped lang="scss">
.app-scroll-top-tooltip {
	position: sticky;
	z-index: 5;
	bottom: calc(6px + env(safe-area-inset-bottom, 0px));
	align-self: flex-end;
	margin-top: -30px;
	margin-right: 8px;

	@media (max-width: 768px) {
		bottom: calc(6px + env(safe-area-inset-bottom, 0px));
	}
}

.app-scroll-top {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	min-width: 30px;
	height: 30px;
	min-height: 30px;
	padding: 0;
	border: 0;
	border-radius: 100%;
	background-color: #D2D2D2;
	cursor: pointer;
	opacity: 0;
	visibility: hidden;
	pointer-events: none;
	transition: background-color 0.1s ease-in-out,
				transform 0.1s ease-in-out,
				opacity 0.15s ease-in-out;

	&:hover {
		background-color: #979797;
		transform: scale(1.1);
	}

	@media (hover: none) {
		&--enabled {
			opacity: 1;
			visibility: visible;
			pointer-events: auto;
		}
	}

	@media (max-width: 768px) {
		bottom: calc(6px + env(safe-area-inset-bottom, 0px));
	}

	@media (max-width: 480px) {
		position: fixed;
		right: 8px;
		align-self: auto;
		margin-right: 0;
	}
}
</style>
